export const ONE_TRUST_CDN_ORIGIN = 'https://cdn.cookielaw.org';
export const ONE_TRUST_GEOLOCATION_ORIGIN = 'https://geolocation.onetrust.com';
export const ONE_TRUST_CONSENT_RECEIPTS_ORIGIN = 'https://privacyportal.onetrust.com';
